<template>
  <div class="sharing-switchers-block">
    <sharing-form-accounts-select
      class="sharing-switchers-block__switcher"
      :selected-account-ids="selectedAccountIds.youtube"
      :accounts="availableAccounts.youtube"
      @updateSelectedAccounts="updateSelectedYoutubeAccounts"
      @renew="$emit('renewYoutube')"
    >
      <template v-slot:icon>
        <img class="sharing-switcher-icon" :src="youtubeIcon" />
      </template>
    </sharing-form-accounts-select>

    <sharing-form-accounts-select
      class="sharing-switchers-block__switcher"
      :selected-account-ids="selectedAccountIds.facebook"
      :accounts="facebookGroupsAndPages"
      placeholder="Select group or page"
      @updateSelectedAccounts="updateSelectedFacebookAccounts"
      @renew="$emit('renewFacebook')"
    >
      <template v-slot:icon>
        <img class="sharing-switcher-icon" :src="facebookIcon" />
      </template>
      <template v-slot:empty>
        No groups or pages
      </template>
    </sharing-form-accounts-select>

    <sharing-form-accounts-select
      class="sharing-switchers-block__switcher"
      :selected-account-ids="selectedAccountIds.instagram"
      :accounts="availableAccounts.instagram"
      @updateSelectedAccounts="updateSelectedInstagramAccounts"
      @renew="$emit('renewInstagram')"
    >
      <template v-slot:icon>
        <img class="sharing-switcher-icon" :src="instagramIcon" />
      </template>
      <template v-slot:empty>
        {{ "No accounts" }}
      </template>
    </sharing-form-accounts-select>

    <sharing-form-accounts-select
      class="sharing-switchers-block__switcher"
      :selected-account-ids="selectedAccountIds.twitter"
      :accounts="availableAccounts.twitter"
      @updateSelectedAccounts="updateSelectedTwitterAccounts"
      @renew="$emit('renewTwitter')"
    >
      <template v-slot:icon>
        <img class="sharing-switcher-icon" :src="twitterIcon" />
      </template>
      <template v-slot:empty>
        {{ "No accounts" }}
      </template>
    </sharing-form-accounts-select>
  </div>
</template>

<script>
import SharingFormAccountsSelect from "@/components/socials/share/SharingFormAccountsSelect.vue";

import youtubeIcon from "@/assets/images/youtube_sharing.png";
import facebookIcon from "@/assets/images/facebook_sharing.png";
import instagramIcon from "@/assets/images/instagram_sharing.png";
import twitterIcon from "@/assets/images/twitter_sharing.png";

// @group Socials
// Header to select accounts to share
export default {
  name: "SharingFormHeader",
  components: {
    SharingFormAccountsSelect
  },
  model: {
    prop: "selectedAccountIds",
    event: "updateSelectedAccounts"
  },
  props: {
    /** selected account identifiers */
    selectedAccountIds: {
      type: Object,
      default() {
        return {
          youtube: [],
          facebook: [],
          instagram: [],
          twitter: []
        };
      }
    },
    /** available to select accounts */
    availableAccounts: {
      type: Object,
      default() {
        return {
          youtube: [],
          facebook: [],
          instagram: [],
          twitter: []
        };
      }
    }
  },
  data() {
    return {
      /** icons */
      youtubeIcon,
      facebookIcon,
      instagramIcon,
      twitterIcon
    };
  },
  computed: {
    // @vuese
    // Facebook groups & pages line IDs in format [accoun-id]_["group"|"page"]_[group-or-page-id]
    facebookGroupsAndPages() {
      const fbAccounts = this.availableAccounts.facebook;

      const fbAccountsFilter = fbAccounts.filter(e => {
        return e.groups != undefined, e.label != undefined;
      });
      /** function to get line id from facebook account information */
      const changeId = (acc, infix, sub) => ({
        ...sub,
        id: `${acc.id}_${infix}_${sub.id}`,
        label: sub.name
      });

      /** list of facebook groups */

      const groups = fbAccountsFilter.reduce((allGroups, account) => {
        const newGroups = account.groups.map(
          changeId.bind(null, account, "group")
        );
        return [...allGroups, ...newGroups];
      }, []);

      /** list of facebook pages */
      const pages = fbAccountsFilter.reduce((allPages, account) => {
        const newPages = account.pages.map(
          changeId.bind(null, account, "page")
        );
        return [...allPages, ...newPages];
      }, []);

      return [...groups, ...pages];
    }
  },
  methods: {
    // @vuese
    // Update selected accounts IDs list in parent component
    updateSelectedAccounts(accounts) {
      /** Change selected accounts lists */
      this.$emit("updateSelectedAccounts", {
        ...this.selectedAccountIds,
        ...accounts
      });
    },
    // @vuese
    // Update selected YouTube accounts IDs list in parent component
    updateSelectedYoutubeAccounts(youtubeIds) {
      this.updateSelectedAccounts({
        youtube: youtubeIds
      });
    },
    // @vuese
    // Update selected Facebook accounts IDs list in parent component
    updateSelectedFacebookAccounts(facebookIds) {
      this.updateSelectedAccounts({
        facebook: facebookIds
      });
    },
    // @vuese
    // Update selected Instagram accounts IDs list in parent component
    updateSelectedInstagramAccounts(instagramIds) {
      this.updateSelectedAccounts({
        instagram: instagramIds
      });
    },
    // @vuese
    // Update selected Twitter accounts IDs list in parent component
    updateSelectedTwitterAccounts(twitterIds) {
      this.updateSelectedAccounts({
        twitter: twitterIds
      });
    }
  }
};
</script>

<style lang="scss">
.sharing-switchers-block {
  display: flex;
  justify-content: space-around;
  padding-bottom: 10px;
}
.sharing-switcher-icon {
  width: 28px;
  height: 28px;
}
.sharing-switcher-account {
  color: white;
}

@media only screen and (max-width: 767px) {
  .sharingModal {
    width: 90%;
  }
  .sharing-switchers-block {
    flex-direction: column;
    align-items: stretch;
  }
  .sharing-switcher .el-select.sharing-switcher-account {
    width: 100%;
  }
}
</style>
